export default {"src":"/_next/static/image/public/images/ic_pl_phone.3c0bdf3fb57e58af554f1ce9dbb8ef0c.svg","height":36,"width":36};